import {
  fetchAdInventory,
  createAdUnit as createAd,
  updateAdUnit as updateAd,
  deleteAdUnit as deleteAd,
} from '../../shared/utils/api';
import {
  FETCH_ADLIST_REQUEST,
  FETCH_ADLIST_SUCCESS,
  FETCH_ADLIST_FAIL,
  CREATE_AD_REQUEST,
  CREATE_AD_SUCCESS,
  CREATE_AD_FAIL,
  UPDATE_AD_REQUEST,
  UPDATE_AD_SUCCESS,
  UPDATE_AD_FAIL,
  DELETE_AD_REQUEST,
  DELETE_AD_SUCCESS,
  DELETE_AD_FAIL,
} from '../../store/types';
import { UI_MESSAGES } from '../../shared/constants';
import { extractContractError } from  '@bafkal/ui-shared/utils';

export const fetchAdList = (page = 1) => async (dispatch) => {
  dispatch({ type: FETCH_ADLIST_REQUEST });
  try {
    const data = await fetchAdInventory(page);
    dispatch({ type: FETCH_ADLIST_SUCCESS, payload: data });
    return data;
  } catch (err) {
    const contractError = extractContractError(err, UI_MESSAGES.AD.FETCH_FAILED);
    dispatch({ type: FETCH_ADLIST_FAIL, payload: contractError });
    throw err;
  }
};

export const createAdUnit = (adData, idempotencyKey) => async (dispatch) => {
  dispatch({ type: CREATE_AD_REQUEST });
  try {
    const data = await createAd(adData, idempotencyKey);
    dispatch({ type: CREATE_AD_SUCCESS, payload: data });
    return data;
  } catch (err) {
    const contractError = extractContractError(err, UI_MESSAGES.AD.CREATE_FAILED);
    dispatch({ type: CREATE_AD_FAIL, payload: contractError });
    throw err;
  }
};

export const updateAdUnit = (id, adData) => async (dispatch) => {
  dispatch({ type: UPDATE_AD_REQUEST });
  try {
    const data = await updateAd(id, adData);
    dispatch({ type: UPDATE_AD_SUCCESS, payload: data });
    return data;
  } catch (err) {
    const contractError = extractContractError(err, UI_MESSAGES.AD.UPDATE_FAILED);
    dispatch({ type: UPDATE_AD_FAIL, payload: contractError });
    throw err;
  }
};

export const deleteAdUnit = (id) => async (dispatch) => {
  dispatch({ type: DELETE_AD_REQUEST });
  try {
    await deleteAd(id);
    dispatch({ type: DELETE_AD_SUCCESS, payload: id });
    return id;
  } catch (err) {
    const contractError = extractContractError(err, UI_MESSAGES.AD.DELETE_FAILED);
    dispatch({ type: DELETE_AD_FAIL, payload: contractError });
    throw err;
  }
};
